export default "__VITE_ASSET__DruObj$B__"